import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { SwiperSlide } from 'swiper/react';

import useGiftsSlider from '../useGiftsSlider';

// Components
import Slider from '../../Slider';
import Heading from '../../Heading';
import Amount from '../../Amount';
import Button from '../../Button';
import VariationInfo from '../../VariationInfo';

// Icons
import PlusIcon from '../../../icons/plus.svg';

// Styles
import styles from './GiftsSlider.styl';

const cx = classNames.bind(styles);

export default function GiftsSlider(props) {
  const { className, withoutButton, vertical } = props;

  const { gifts, isLoading, onAddClick } = useGiftsSlider();

  if (!gifts.list.length) {
    return null;
  }

  if (vertical) {
    return (
      <div className={cx('GiftsSlider', 'GiftsSlider_vertical', className)}>
        {gifts.list.map(gift => (
          <div className={cx('GiftsSlider__slide')} key={gift.sku}>
            <div className={cx('GiftsSlider__slide-image')}>
              <img src={gift.item.image} alt={gift.item.name} />
            </div>
            <div className={cx('GiftsSlider__slide-group')}>
              <Heading className={cx('GiftsSlider__slide-name')} level={4} medium>
                {gift.item.name}
              </Heading>
              <VariationInfo {...gift.item} className={cx('GiftsSlider__slide-description')} />
            </div>
            <div className={cx('GiftsSlider__slide-end')}>
              <Amount
                className={cx('GiftsSlider__slide-amount')}
                value={gift.points}
                size="s"
                bonus
              />
              {!withoutButton && (
                <Button
                  className={cx('GiftsSlider__slide-button')}
                  onClick={() => onAddClick(gift)}
                  isLoading={isLoading.includes(gift.sku)}
                >
                  <PlusIcon className={cx('GiftsSlider__slide-plus')} />
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }

  const swiperParams = {
    slidesPerView: 'auto',
    spaceBetween: 15,
  };

  return (
    <Slider
      className={cx('GiftsSlider', className)}
      isOutsideNavigation
      swiperParams={swiperParams}
    >
      {gifts.list.map(gift => (
        <SwiperSlide className={cx('GiftsSlider__slide')} key={gift.sku}>
          <div className={cx('GiftsSlider__slide-image')}>
            <img src={gift.item.image} alt={gift.item.name} />
          </div>
          <div className={cx('GiftsSlider__slide-group')}>
            <Heading className={cx('GiftsSlider__slide-name')} level={4} medium>
              {gift.item.name}
            </Heading>
            <VariationInfo {...gift.item} className={cx('GiftsSlider__slide-description')} />
          </div>
          <div className={cx('GiftsSlider__slide-end')}>
            <Amount
              className={cx('GiftsSlider__slide-amount')}
              value={gift.points}
              size="s"
              bonus
            />
            {!withoutButton && (
              <Button
                className={cx('GiftsSlider__slide-button')}
                onClick={() => onAddClick(gift)}
                isLoading={isLoading.includes(gift.sku)}
              >
                <PlusIcon className={cx('GiftsSlider__slide-plus')} />
              </Button>
            )}
          </div>
        </SwiperSlide>
      ))}
    </Slider>
  );
}

GiftsSlider.defaultProps = {
  className: '',
  withoutButton: false,
  vertical: false,
};

GiftsSlider.propTypes = {
  className: PropTypes.string,
  withoutButton: PropTypes.bool,
  vertical: PropTypes.bool,
};
